import React from 'react';
import { Grid } from '@material-ui/core';
import useStyles from '../../assets/jss/layout-styles';

const NotLoggedIn = () => {
  const classes = useStyles();
  return (
    <Grid container className={classes.notLoggedIn} spacing={0} direction='column' alignItems='center' justify='center'>
      <Grid item xl={6} className={classes.logoContainer}>
        <img src='/SSSF_color_logo.png' alt='SSSF Logo' />
      </Grid>
    </Grid>
  );
};
export default NotLoggedIn;
